<template>
  <div class="badges-list">
    <div class="badge-buttons">
      <button class="badge-prev" v-if="pageNumber > 0" v-on:click="previousPage">Prev</button>
      <button class="badge-next" v-if="badges.length % 50 === 0" v-on:click="nextPage">Next</button>
    </div>
    <div class="badge" v-for="badge in badges" :key="badge.id" :class="{isAchieved: badge.userstat.achieved}">
      <div class="avatar">
        <img :src="badge.media.url" alt="">
      </div>
      <div class="resume">
        <span class="name">{{ badge.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import HTTP from '@rocketfid/api'
import { mapGetters } from 'vuex'

export default {
  name: 'customer-badges-list',

  props: {
    id: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      badges: [],
      pageNumber: 0
    }
  },

  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },

  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },

  methods: {
    init () {
      this.getBadgesByPage()
    },

    getBadgesByPage () {
      HTTP.axios.get(process.env.API + '/user/' + this.id + '/achievements/' + this.pageNumber + '/50/')
        .then((result) => {
          this.badges = [ ...result.data ]
        })
    },

    previousPage () {
      this.pageNumber--
      this.getBadgesByPage()
    },

    nextPage () {
      this.pageNumber++
      this.getBadgesByPage()
    }
  }
}

</script>

<style lang="scss" scoped>
.badges-list {
    box-sizing: border-box;
    padding: 12px;
    overflow-y: auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 12px;
}
.badge-buttons {
  grid-column: 1/5;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 10px;
  button {
    width: 65px;
    font-weight: 600;
    border: 2px solid black;
    background: #fff;
    padding: 5px;
    cursor: pointer;
  }
  button:hover {
    background: #FBBE36;
    color: #fff;
    border-color: #FBBE36;
  }
  .badge-prev {
    grid-column: 2/3;
    justify-self: end;
  }
  .badge-next {
    grid-column: 3/4;
  }
}
.badge {
    opacity: 0.4;
    padding: 12px;
    margin-bottom: 8px;
    display: grid;
    grid-template-columns: 1fr;
    text-align: center;

    .name {
        font-weight: 600;
    }
    .avatar {
        width: 100%;
        text-align: center;
        img {
            border-radius: 4px;
            width: 60px;
            display: inline-block;
            margin:4px auto;
        }
    }

    &.isAchieved {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/customers/customer-badges-list.vue